import { render, staticRenderFns } from "./PublicRoleHeader.vue?vue&type=template&id=03c55d9c&"
import script from "./PublicRoleHeader.vue?vue&type=script&lang=ts&"
export * from "./PublicRoleHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports